module.exports = __webpack_public_path__ + "img/allrooms.195fd775.jpg";